import { Epic, ofType } from 'redux-observable';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { toast } from 'react-toastify';

import { GENERAL } from '../../../constants';
import { handleError } from '../core/operators';
import { IAction, IEpicDependencies, IRootState } from '../rootState';
import { coreState } from '../core';
import { generalState } from '../general';
import { actions, ActionType } from './actions';
import { GeneralModel } from 'modules/models';
import { expandedWidgets, expandedWidgetsExportLoaderMapper } from 'utils/dashboardUtils';

export const fetchWfmExpandedWorkersOnsiteStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_WFM_EXPANDED_WORKERS_ONSITE_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_ONSITE, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchWfmExpandedWorkersOnsiteSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_ONSITE, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_ONSITE))
    )
  );

export const fetchWfmExpandedCompaniesOnsiteStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_WFM_EXPANDED_COMPANIES_ONSITE_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_COMPANIES_ONSITE, true)),
        deps.apiService.getExpandedCompanies(payload.query).pipe(map(res => actions.fetchWfmExpandedCompaniesOnsiteSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_COMPANIES_ONSITE, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_COMPANIES_ONSITE))
    )
  );

export const fetchWfmExpandedWorkersForCompanyOnsiteStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchWfmExpandedWorkersForCompanyOnsiteSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_FOR_COMPANY_ONSITE))
    )
  );

export const fetchWfmExpandedTradesOnsiteStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_WFM_EXPANDED_TRADES_ONSITE_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_TRADES_ONSITE, true)),
        deps.apiService.getExpandedTrades(payload.query).pipe(map(res => actions.fetchWfmExpandedTradesOnsiteSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_TRADES_ONSITE, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_TRADES_ONSITE))
    )
  );

export const fetchWfmExpandedWorkersForTradeOnsiteStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchWfmExpandedWorkersForTradeOnsiteSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_WFM_EXPANDED_WORKERS_FOR_TRADE_ONSITE))
    )
  );

export const fetchDailyLogExpandedTotalTradesStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES, true)),
        deps.apiService.getExpandedTrades(payload.query).pipe(map(res => actions.fetchDailyLogExpandedTradesOnsiteSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_TRADES))
    )
  );

export const fetchDailyLogExpandedWorkersForTotalTradeStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchDailyLogExpandedWorkersForTotalTradeSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_TRADE))
    )
  );

export const fetchDailyLogExpandedNewWorkersBadgedStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchDailyLogExpandedNewWorkersBadgedSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_NEW_WORKERS_BADGED))
    )
  );

export const fetchDailyLogExpandedNewCompaniesEnrolledStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED, true)),
        deps.apiService.getExpandedCompanies(payload.query).pipe(map(res => actions.fetchDailyLogExpandedNewCompaniesEnrolledSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_NEW_COMPANIES_ENROLLED))
    )
  );

export const fetchDailyLogExpandedWorkersForNewCompanyStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchDailyLogExpandedWorkersForNewCompanySuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_NEW_COMPANY))
    )
  );

export const fetchDailyLogExpandedTotalHeadcountStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchDailyLogExpandedTotalHeadcountSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_HEADCOUNT))
    )
  );

export const fetchDailyLogExpandedTotalCompaniesStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES, true)),
        deps.apiService.getExpandedCompanies(payload.query).pipe(map(res => actions.fetchDailyLogExpandedTotalCompaniesSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_COMPANIES))
    )
  );

export const fetchDailyLogExpandedWorkersForTotalCompanyStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchDailyLogExpandedWorkersForTotalCompanySuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_WORKERS_FOR_TOTAL_COMPANY))
    )
  );

export const fetchDailyLogExpandedTotalOnsiteHoursStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS, true)),
        deps.apiService.getExpandedWorkers(payload.query).pipe(map(res => actions.fetchDailyLogExpandedTotalOnsiteHoursSuccess(res))),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_DAILY_LOG_EXPANDED_TOTAL_ONSITE_HOURS))
    )
  );

export const fetchInProgressWidgetExportsStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.FETCH_IN_PROGRESS_WIDGET_EXPORTS_START),
    mergeMap(({ payload }) =>
      concat(
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_IN_PROGRESS_WIDGET_EXPORTS, true)),
        deps.apiService.getDashboardWidgetDownloads(payload.query).pipe(
          map(res => {
            const inProgressExports = {};
            res?.items?.forEach?.(item => {
              inProgressExports[item.type] = true;
            });
            return actions.fetchInProgressWidgetExportsSuccess(inProgressExports);
          })
        ),
        of(generalState.actions.setLoading(GENERAL.LOADING_KEY.FETCH_IN_PROGRESS_WIDGET_EXPORTS, false))
      ).pipe(handleError(GENERAL.LOADING_KEY.FETCH_IN_PROGRESS_WIDGET_EXPORTS))
    )
  );

export const exportWidgetDataStart: Epic<IAction, IAction, IRootState, IEpicDependencies> = (action$, state$, deps) =>
  action$.pipe(
    ofType(ActionType.EXPORT_WIDGET_DATA_START),
    mergeMap(({ payload }) =>
      concat(
        of(
          generalState.actions.setLoading(
            GENERAL.LOADING_KEY[expandedWidgetsExportLoaderMapper[payload?.widget] || expandedWidgetsExportLoaderMapper[expandedWidgets.wfmWorkersOnsite]],
            true
          )
        ),
        deps.apiService.exportWidgetData(payload.query).pipe(
          mergeMap(() => {
            toast.success('Generating file download', {
              theme: 'colored',
              toastId: Date.now(),
              autoClose: 5000,
            });
            return [actions.fetchInProgressWidgetExportsStart({ clientSidePaging: true, inProcessOnly: true })];
          })
        ),
        of(
          generalState.actions.setLoading(
            GENERAL.LOADING_KEY[expandedWidgetsExportLoaderMapper[payload?.widget] || expandedWidgetsExportLoaderMapper[expandedWidgets.wfmWorkersOnsite]],
            false
          )
        )
      ).pipe(
        catchError(error => {
          return of(
            coreState.actions.epicError(error),
            generalState.actions.setLoading(
              GENERAL.LOADING_KEY[expandedWidgetsExportLoaderMapper[payload?.widget] || expandedWidgetsExportLoaderMapper[expandedWidgets.wfmWorkersOnsite]],
              false,
              true,
              error
            ),
            generalState.actions.addToastStart(
              error.response?.errors
                ? Object.values(error.response.errors || {})
                    .flat()
                    .join(', ')
                : error.title || error.message,
              GeneralModel.ToastType.ERROR
            )
          );
        })
      )
    )
  );

export const epics = [
  fetchWfmExpandedWorkersOnsiteStart,
  fetchWfmExpandedCompaniesOnsiteStart,
  fetchWfmExpandedWorkersForCompanyOnsiteStart,
  fetchWfmExpandedTradesOnsiteStart,
  fetchWfmExpandedWorkersForTradeOnsiteStart,
  fetchDailyLogExpandedTotalTradesStart,
  fetchDailyLogExpandedWorkersForTotalTradeStart,
  fetchDailyLogExpandedNewWorkersBadgedStart,
  fetchDailyLogExpandedNewCompaniesEnrolledStart,
  fetchDailyLogExpandedWorkersForNewCompanyStart,
  fetchDailyLogExpandedTotalHeadcountStart,
  fetchDailyLogExpandedTotalCompaniesStart,
  fetchDailyLogExpandedWorkersForTotalCompanyStart,
  fetchDailyLogExpandedTotalOnsiteHoursStart,
  fetchInProgressWidgetExportsStart,
  exportWidgetDataStart,
];
